import React from 'react';
import { NavLink } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import ArchiveIcon from '@mui/icons-material/Archive';
import LoginIcon from '@mui/icons-material/Login';
import LoginDashboard from './LoginDashboard';
import { Description } from '@mui/icons-material';

function Sidebar() {
  const navItems = [
    {
      to: '/dashboard',
      label: 'Main Dashboard',
      description: 'Overview of Confluent',
      icon: <DashboardIcon sx={{ fontSize: 22 }} />,
      end: true,
    },
    {
      to: '/dashboard/path1',
      label: 'Path 1',
      description: 'Legacy Logs',
      icon: <BackupTableIcon sx={{ fontSize: 22 }} />,
    },
    {
      to: '/dashboard/path2',
      label: 'Path 2',
      description: 'Filtered Logs',
      icon: <FilterAltIcon sx={{ fontSize: 22 }} />,
    },
    {
      to: '/dashboard/path3',
      label: 'Path 3',
      description: 'AI-Enriched Logs',
      icon: <AutoAwesomeIcon sx={{ fontSize: 22 }} />,
    },
    {
      to: '/dashboard/path4',
      label: 'Path 4',
      description: 'Archive Logs( Threat hunting)',
      icon: <ArchiveIcon sx={{ fontSize: 22 }} />,
    },
    {
      to: '/dashboard/logindashboard',
      label: 'SIEM Login',
      description: 'SIEM login',
      icon: <LoginIcon sx={{ fontSize: 22 }} />,
    }
  ];

  return (
    <nav className="dashboard-sidebar" style={{
      width: 240,
      height: '100%',
      background: 'rgba(10,34,64,0.98)',
      color: '#e0f7fa',
      padding: '32px 0 24px 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      borderRight: '1.5px solid #1e90ff',
      boxShadow: '0 4px 24px 0 rgba(30,144,255,0.10)',
    }}>
      {/* Header Section */}
      <div style={{
        padding: '0 24px 24px 24px',
        borderBottom: '1px solid rgba(30, 144, 255, 0.2)',
        marginBottom: 20,
      }}>
        <h2 style={{
          margin: 0,
          fontSize: 20,
          fontWeight: 700,
          background: 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          textAlign: 'center',
          letterSpacing: '0.5px',
        }}>
          Confluent COE
        </h2>
      </div>
      
      <ul style={{
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}>
        {navItems.map((item) => (
          <li key={item.to} style={{ width: '100%' }}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                'sidebar-link' + (isActive ? ' active' : '')
              }
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                padding: '16px 24px',
                borderRadius: 12,
                fontWeight: 700,
                fontSize: 16,
                color: isActive ? '#fff' : '#e0f7fa',
                background: isActive
                  ? 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)'
                  : 'transparent',
                boxShadow: isActive
                  ? '0 2px 12px rgba(30, 144, 255, 0.12)'
                  : 'none',
                transition: 'all 0.2s',
                cursor: 'pointer',
                textDecoration: 'none',
                margin: '0 12px',
              })}
            >
              {item.icon}
              <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <span style={{ fontSize: 16, fontWeight: 700 }}>
                  {item.label}
                </span>
                <span style={{ 
                  fontSize: 12, 
                  fontWeight: 400, 
                  opacity: 0.7,
                  lineHeight: 1.2,
                  marginTop: 2 
                }}>
                  {item.description}
                </span>
              </div>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Sidebar;
